/*jshint browser: true */

require(['jquery', 'core'], function ($) {
    'use strict';

    var $search = $('#provider-search');

    // provider search - get Selected Plans and set hidden fields to pass to provider search
    $('body').on('click', '#save-plans', function () {
        var selectedPlans = $('#plan-types input[type="checkbox"]:checked').map(function () { return ' ' + this.value; }).get(),
            planFilter = $.trim(selectedPlans).split(',');

        $search.find('input[type="hidden"]').remove();

        $.each(planFilter, function () {
            $search.append('<input type="hidden" name="plans" value="' + $.trim(this) + '" />');
        });

        $('#selected-plans').val($.trim(selectedPlans));
        $('#provider-search').submit();
    });

    $('a[data-map-reason]').click(function () {
        var reason = $(this).data('mapReason');
        var mapUrl = $('#map-frame').attr('src').replace(/\?.+$/, '') + '?reason=' + reason;

        $('#map-frame').attr('src', mapUrl);
    });
});
define("home", function(){});

